import moment from 'moment';

const B2bRfqDetailField = ({ fieldkey, value, isFirstElement, isLastElement }) => {
  const getB2bRfqDetailFieldLabel = (fieldkey) => {
    switch (fieldkey) {
      case 'name':
        return 'Full Name';
      case 'phone':
        return 'Phone number';
      case 'email':
        return 'Email Id';
      case 'custom_message':
        return 'Your message';
      case 'address':
        return 'Address';
      case 'date_and_time':
        return 'Date and Time';
      case `gst`:
        return 'GST';
      default:
        return '';
    }
  };

  const getModifiedDateFormat = (dateValue) => {
    const date = new Date(dateValue);
    const options = {
      timeZone: 'Asia/Kolkata',
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    };
    const formattedDate = date.toLocaleString('en-US', options);
    const modifiedDate = formattedDate.replace(
      /(\d+)(\/)(\w+)(\/)(\d+)(\s)(\d+):(\d+)\s(.+)/,
      '$3 $1, $5, $7:$8 $9'
    );
    return moment(modifiedDate).format('h:mm A, DD MMM, YYYY');
  };

  if (!value) return null;
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: !isLastElement ? '1.16944px dashed #9C9FAA' : '',
      }}
    >
      <p
        className="mv0"
        style={{
          width: '50%',
          color: '#9C9FAA',
          fontSize: 14,
          fontWeight: 400,
          padding: isFirstElement ? '8px 0px 18px 0px' : '18px 0px',
        }}
      >
        {getB2bRfqDetailFieldLabel(fieldkey)}:
      </p>
      <p
        className="mv0"
        style={{
          width: '50%',
          color: '#000000',
          fontSize: 14,
          fontWeight: 400,
          textAlign: 'right',
          padding: isFirstElement ? '8px 0px 18px 0px' : '18px 0px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {fieldkey === 'date_and_time' ? getModifiedDateFormat(value) : value}
      </p>
    </div>
  );
};

export default B2bRfqDetailField;
